import { SVGProps } from 'react';
import { ReactComponent as CrossIcon } from '@packages/shared/assets/cross.svg';
import IconButton, { IconButtonProps } from '../IconButton';

type CloseButtonProps = {
  iconProps?: SVGProps<SVGSVGElement>;
} & Omit<IconButtonProps, 'children'>;

const CloseButton = ({ iconProps = {}, ...props }: CloseButtonProps) => {
  return (
    <IconButton {...props}>
      <CrossIcon {...iconProps} />
    </IconButton>
  );
};

export default CloseButton;
